
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    expanded: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      showExpandableContent: false
    };
  },
  mounted: function mounted() {
    if (this.expanded) this.expandToggle();
  },
  methods: {
    expandToggle: function expandToggle() {
      this.showExpandableContent = !this.showExpandableContent;
      this.$refs.expandableContent.classList.toggle('expanded');
      this.$refs.expandableButton.classList.toggle('expanded');
      this.$refs.expandableContainer.classList.toggle('expanded');
    }
  }
};